export default "__VITE_ASSET__Bax2akfp__"